// removed by extract-text-webpack-plugin
module.exports = {"item-list":"_3v1N5P96F9H3TdS6E5mc9f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/itemList/itemList.css
// module id = 39
// module chunks = 0